import React, { forwardRef } from 'react';
import { StyledSubMenuLine, StyledSubmenusContainer, StyledMenusContainer } from './styled';
import { Link as LinkType } from '~/lib/data-contract';
import { SideMenuLink } from './components/SideMenuLink';

export interface SideMenuItemViewModel {
    name: string;
    url: string;
    pageId?: number;
    children?: SideMenuItemViewModel[];
}

interface SideMenuProps {
    menus?: SideMenuItemViewModel[];
    breadcrumbs?: LinkType[];
}

/**
 * A side bar menu navigation based on accordions.
 * It can have childs that can be accordions or list of links.
 */
export const N40SideMenu = forwardRef<HTMLDivElement, SideMenuProps>(
    ({ menus, breadcrumbs, ...rest }, ref) => (
        <div ref={ref} {...rest}>
            {menus?.map((menu, index) => {
                const isCurrentMenu =
                    (breadcrumbs?.findIndex((crumb) => crumb.url == menu.url) ?? -1) > -1; // If path is in breadcrumb items if should start be open.

                return (
                    <React.Fragment key={index}>
                        <SideMenuLink
                            menu={menu}
                            key={index}
                            level="level0"
                            breadcrumbs={breadcrumbs}
                        />
                        {menu.children && menu.children?.length && isCurrentMenu ? (
                            <StyledMenusContainer>
                                <StyledSubMenuLine />
                                {menu.children?.map((item, itemIndex) => {
                                    // If path is in breadcrumb items if should start be open.
                                    const isSubmenuCurrent =
                                        (breadcrumbs?.findIndex((crumb) => crumb.url == item.url) ??
                                            -1) > -1;

                                    return (
                                        <React.Fragment key={itemIndex}>
                                            <SideMenuLink
                                                menu={item}
                                                key={itemIndex}
                                                level="level1"
                                                breadcrumbs={breadcrumbs}
                                            />
                                            {item?.children &&
                                            item?.children?.length &&
                                            isSubmenuCurrent ? (
                                                <StyledSubmenusContainer>
                                                    {item?.children?.map(
                                                        (subitem, subItemIndex) => (
                                                            <SideMenuLink
                                                                menu={subitem}
                                                                level="level1"
                                                                key={subItemIndex}
                                                                breadcrumbs={breadcrumbs}
                                                            />
                                                        )
                                                    )}
                                                </StyledSubmenusContainer>
                                            ) : null}
                                        </React.Fragment>
                                    );
                                })}
                            </StyledMenusContainer>
                        ) : null}
                    </React.Fragment>
                );
            })}
        </div>
    )
);
